export const UiDropdown: FcDiv = ({ children }) => {
  return (
    <div className="absolute right-0 z-10 mt-1 hidden w-[15rem] overflow-hidden rounded-[0.9375rem] border border-[#EBEBEB] bg-white shadow-custom1 group-hover:block sm:right-[unset]">
      {children}
    </div>
  );
};
